<div class="toast" *ngIf="notification.showModal">
    <div>{{ notification.showMessage | translate }}</div>
</div>
